import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAPI } from '@/hooks/useAPI'
import { getPartnerDetail } from '@/services/api/partners'
import PartnerDetail from '@/components/business/Partner/PartnerDetail'

const PartnerDetailPage = () => {
  const { t, i18n } = useTranslation()
  const { id } = useParams()
  
  // 获取合作伙伴详情数据
  const { data: partner, loading, error } = useAPI(
    () => getPartnerDetail(id),
    [id, i18n.language]
  )

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">{t('partners.states.loading')}</p>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="text-red-500 mb-4">
            <svg className="w-16 h-16 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <h2 className="text-xl font-medium text-gray-900 mb-2">{t('partners.states.loadFailed')}</h2>
            <p className="text-gray-600 mb-4">{t('partners.states.noResults')}</p>
            <button 
              onClick={() => window.location.reload()}
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md transition-colors"
            >
              {t('partners.states.retry')}
            </button>
          </div>
        </div>
      </div>
    )
  }

  return <PartnerDetail partner={partner} />
}

export default PartnerDetailPage 